const Section = ({ title, children }) => (
    <section className="mt-8">
        <h2 className="font-serif-display text-2xl font-semibold">{title}</h2>
        <div className="mt-3 text-sm leading-relaxed text-[var(--sss-text-muted)] space-y-3">{children}</div>
    </section>
);

export default function RefundPolicy() {
    return (
        <div className="max-w-3xl mx-auto px-4 md:px-8 py-12" data-testid="refund-policy-page">
            <p className="text-center text-xs uppercase tracking-[0.2em] font-semibold text-[var(--sss-pink)]">Legal</p>
            <h1 className="font-serif-display text-4xl md:text-5xl font-bold text-center mt-2">Refund &amp; Cancellation Policy</h1>
            <p className="text-center text-sm text-[var(--sss-text-muted)] mt-3">Last updated: June 2026</p>

            <div className="bg-white rounded-3xl sss-shadow p-6 md:p-10 mt-10">
                <p className="text-sm leading-relaxed text-[var(--sss-text-muted)]">
                    Every treat from Sugar Sweet Society is handmade fresh to order. Because our products are perishable food items, we handle refunds and cancellations as follows.
                </p>

                <Section title="Cancellations">
                    <p><strong className="text-[var(--sss-text)]">Standard orders:</strong> may be cancelled up to <strong className="text-[var(--sss-text)]">48 hours</strong> before your delivery date for a full refund. Cancellations within 48 hours are not eligible for a refund, as ingredients are purchased and preparation has begun.</p>
                    <p><strong className="text-[var(--sss-text)]">Custom orders:</strong> require a deposit which is <strong className="text-[var(--sss-text)]">non-refundable</strong> once your order is confirmed and materials are purchased. The remaining balance is refundable if you cancel at least 48 hours before your event date.</p>
                </Section>

                <Section title="Refunds">
                    <p>Because all items are perishable and made fresh, we cannot accept returns and cannot refund orders after delivery.</p>
                    <p>If something is wrong with your order (wrong item, quality issue), contact us within <strong className="text-[var(--sss-text)]">24 hours</strong> of receiving it with a photo, and we will make it right with a remake, credit, or refund at our discretion.</p>
                    <p>Approved refunds for card payments are returned to your original payment method within 5–10 business days. Cash App / PayPal / Apple Pay refunds are sent back through the same app.</p>
                </Section>

                <Section title="Failed Deliveries">
                    <p>Please ensure someone is available at the address provided at the scheduled delivery time. Perishable items left as instructed are the customer&apos;s responsibility after drop-off. If delivery cannot be completed, we will contact you to reschedule within 24 hours; orders that cannot be redelivered are forfeited without refund, as freshness cannot be guaranteed.</p>
                </Section>

                <Section title="Allergens">
                    <p>Our treats are made in a kitchen that handles milk, soy, wheat, peanuts, and tree nuts. Please note allergies in your order — we cannot refund orders due to undisclosed allergies.</p>
                </Section>

                <Section title="Questions">
                    <p>
                        Contact us anytime at <a href="mailto:Laylah@sugarsweetsociety.com" className="underline text-[var(--sss-pink)]">Laylah@sugarsweetsociety.com</a> — we are a small business and we truly want you to love your order.
                    </p>
                </Section>
            </div>
        </div>
    );
}
